import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const IconsOuterWrapper = styled.div((props) => ({
  display: 'flex',
  flexWrap: 'wrap',
  width: '300px',
  height: '400px',
  borderRadius: '10px',
  justifyContent: 'center',
  padding: '1.5rem 0',
  border: '1px solid #ccc',
  overflow: 'scroll',
  boxShadow: '0 0 0.25rem 0.125rem rgba(0, 0, 0, 0.075)',
  margin: 'auto',
  // marginBottom: '1rem',
}));

const IconsWrapper = styled.div(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
  gap: '1rem',
}));

const Icons = ({ iconsListLength = 235, handleIconChange }) => {
  const [iconContents, setIconContents] = useState([]);

  useEffect(() => {
    let _iconContents = [];
    Array.from(Array(iconsListLength).keys()).forEach((i) => {
      const iconElm = document.getElementById('icon-' + i);
      let res;
      if (iconElm instanceof Element) {
        res = window.getComputedStyle(iconElm, ':before').content;
      }

      if (res)
        _iconContents.push({
          name: `icon-${i}`,
          content: res.replaceAll('"', ''),
        });
      setIconContents(_iconContents);
    });
  }, []);

  return (
    <IconsOuterWrapper>
      <IconsWrapper>
        {Array.from(Array(235).keys()).map((i, ind) =>
          ind > 0 ? (
            <i
              key={ind}
              id={`icon-${ind}`}
              onClick={(e) =>
                handleIconChange({
                  id: e.target.id,
                  ind,
                  allIcons: iconContents,
                })
              }
              className={`icon font-xxxlg icon-service icon-${ind} cursor-pointer b-lighterGray radius-sm`}
            />
          ) : null
        )}
      </IconsWrapper>
    </IconsOuterWrapper>
  );
};

export default Icons;
